export const DEFAULT_PORTAL_FONT = 'default';

export const PORTAL_FONT_OPTIONS = [
  { value: 'default', label: 'Default (Arial + IBM Plex Mono)' },
  { value: 'Arial', label: 'Arial', stack: 'Arial, Helvetica, sans-serif' },
  { value: 'Segoe UI', label: 'Segoe UI', stack: '"Segoe UI", Arial, sans-serif' },
  { value: 'Verdana', label: 'Verdana', stack: 'Verdana, Geneva, sans-serif' },
  { value: 'Tahoma', label: 'Tahoma', stack: 'Tahoma, Geneva, sans-serif' },
  { value: 'Trebuchet MS', label: 'Trebuchet MS', stack: '"Trebuchet MS", Arial, sans-serif' },
  { value: 'Georgia', label: 'Georgia', stack: 'Georgia, "Times New Roman", serif' },
];

export function normalizePortalFont(value) {
  return PORTAL_FONT_OPTIONS.some(option => option.value === value) ? value : DEFAULT_PORTAL_FONT;
}

export function fontTokensForBranding(value) {
  const stack = PORTAL_FONT_OPTIONS.find(option => option.value === value)?.stack;
  return stack
    ? { sans: stack, mono: stack, heading: stack }
    : { sans: 'Arial, sans-serif', mono: "'IBM Plex Mono', monospace", heading: "'Syne', sans-serif" };
}

export function applyFontTokens(fonts) {
  for (const key of ['sans', 'mono', 'heading']) {
    document.documentElement.style.setProperty(`--font-${key}`, fonts[key]);
  }
}
